<template>
  <div>
    <div class="fixed-top bg-white border-bottom shadow-sm">
      <div
        id="banner"
        class="d-flex flex-md-row justify-content-between align-items-center p-1 px-md-4"
      >
        <nav class="my-1 mr-md-auto">
          <router-link to="/">
            <img
              id="cedience-logo"
              src="@/assets/cedience_logo.png"
              alt="Cedience"
            />
          </router-link>
        </nav>
        <nav class="top-right-links my-md-0 mr-md-3">
          <!-- <b-button
            v-if="!acceptedSwitchNewUI"
            id="switch-new-ui-button"
            class="mx-3"
            @click="openSwitchNewUIModal()"
            >Switch to our New Platform</b-button
          >
          <b-button
            v-else
            id="switch-new-ui-button"
            class="mx-3"
            :href="
              isProd
                ? 'https://platform.cedience.com'
                : 'https://stagingplatform.cedience.com'
            "
            target="_blank"
            >Access our New Platform</b-button
          > -->
          <b-button
            id="switch-new-ui-button"
            class="mx-3"
            :href="
              isProd
                ? 'https://platform.cedience.com'
                : 'https://stagingplatform.cedience.com'
            "
            target="_blank"
            >Access our New Platform</b-button
          >
          <NotificationsPopover />
          <span v-show="showProductTour">
            <a
              id="product-tour-link"
              class="link mx-md-1 link px-2 text-secondary"
              target="_blank"
              @click="$emit('start-product-tour')"
              >Product Tour
            </a>
            |</span
          >
          <a
            id="logout"
            class="link mx-md-1 link px-2 text-secondary"
            @click="verifyLogout()"
            >Logout
          </a>
        </nav>
      </div>

      <div class="project-line mb-2">
        <hr size="1" class="mt-2 mb-2" />
        <router-link
          :to="{
            name: 'ProjectListPage',
          }"
          class="project-line-item"
          ><span id="all-projects-tour"
            ><b-icon icon="folder2-open" aria-hidden="true"></b-icon> All
            Projects</span
          ></router-link
        >
        <span v-if="projectName" class="project-line-item"
          ><b-icon icon="chevron-right" aria-hidden="true"></b-icon
          >&nbsp;<b-icon
            :icon="savedResults ? 'folder2-open' : 'folder-check'"
            aria-hidden="true"
          ></b-icon>
          <span class="saved-results-link" @click="projectNameBtnClicked">
            {{ projectName }}</span
          >
        </span>
        <span v-if="savedResults" class="project-line-item"
          ><b-icon icon="chevron-right" aria-hidden="true"></b-icon
          >&nbsp;<b-icon icon="folder-check" aria-hidden="true"></b-icon>
          <span class="saved-results-link"> Project Log </span>
        </span>
        <span v-else-if="projectName" class="project-line-item-inactive"
          ><b-icon icon="chevron-right" aria-hidden="true"></b-icon>&nbsp;
          <span
            id="view-project-log-tour"
            class="saved-results-link"
            @click="projectLogBtnClicked"
          >
            View Project Log
          </span>
        </span>
      </div>
    </div>

    <b-modal
      id="logout-modal"
      size="md"
      no-close-on-backdrop
      hide-header
      hide-footer
    >
      <div class="text-center">
        Are you sure you want to log out?
        <br /><br />
        <b-button
          id="logout-confirm"
          class="mx-2"
          variant="outline-secondary"
          @click="logout"
        >
          Yes
        </b-button>
        <b-button
          id="logout-cancel"
          class="mx-2"
          variant="outline-secondary"
          @click="cancelLogout"
        >
          No
        </b-button>
      </div>
    </b-modal>
    <b-modal
      id="request-support-modal"
      size="lg"
      hide-header
      hide-footer
      @hide="loadedSupportForm = false"
    >
      <iframe
        class="airtable-embed"
        src="https://airtable.com/embed/shrkvBI34E5O9rCXO?backgroundColor=blue"
        frameborder="0"
        onmousewheel=""
        width="100%"
        height="533"
        style="background: transparent; border: 1px solid #ccc"
        @load="loadedSupportForm = true"
      ></iframe>
      <span v-if="!loadedSupportForm">Loading...</span>
    </b-modal>
    <b-modal
      id="send-feedback-modal"
      size="lg"
      hide-header
      hide-footer
      @hide="loadedFeedbackForm = false"
    >
      <iframe
        class="airtable-embed"
        src="https://airtable.com/embed/shrgFhWDzbjw5Q6Yv?backgroundColor=blue"
        frameborder="0"
        onmousewheel=""
        width="100%"
        height="533"
        style="background: transparent; border: 1px solid #ccc"
        @load="loadedFeedbackForm = true"
      ></iframe>
      <span v-if="!loadedFeedbackForm">Loading...</span>
    </b-modal>
    <b-modal
      id="logged-out-modal"
      size="md"
      centered
      no-close-on-backdrop
      hide-header
      hide-footer
    >
      <div class="text-center">
        Your session has expired.
        <br /><br />
        <b-button class="mx-2" variant="outline-secondary" @click="reload">
          Sign In
        </b-button>
      </div>
    </b-modal>
    <b-modal
      id="disclaimer-modal"
      size="md"
      no-close-on-backdrop
      hide-header
      hide-footer
    >
      <div class="text-center">
        <strong>Disclaimer</strong>
        <br />
        All information, content, and materials provided by this application are
        for general informational purposes only and do not constitute or are not
        intended to constitute official regulatory advice.
        <br />
        By clicking Accept, you agree to our
        <a href="https://www.biotechsquare.com/terms" target="_blank"
          >Terms of Use</a
        >
        and
        <a href="https://www.biotechsquare.com/privacy" target="_blank"
          >Privacy Policy</a
        >.
        <br />
        <br />
        <b-button
          id="disclaimer-accept"
          variant="outline-secondary"
          @click="acceptDisclaimer"
        >
          Accept
        </b-button>
        <b-button
          id="disclaimer-decline"
          class="ml-1"
          variant="outline-secondary"
          @click="logout"
        >
          Decline & Logout
        </b-button>
      </div>
    </b-modal>
    <b-modal id="switch-new-ui-modal" size="lg" hide-header hide-footer>
      <div class="text-center">
        <div v-show="acceptedSwitchNewUILoading">
          <b-spinner> </b-spinner>
        </div>
        <div v-show="!acceptedSwitchNewUI && !acceptedSwitchNewUILoading">
          <h3>Switch to our new platform!</h3>
          <div>
            We heard your feedback, and are happy to announce the launch of our
            new platform that is more user friendly and makes it easier for you
            to research and manage your information.
          </div>
          <br />
          <div>
            We have also implemented Single Sign On in the new platform. So, if
            your email belongs to a Google or Microsoft workspace, you can login
            directly via Google or Microsoft. Otherwise, you can access the new
            platform using the credentials sent to you via email.
          </div>
          <br />
          <b-button
            id="switch-new-ui-accept"
            variant="outline-secondary"
            @click="acceptSwitchNewUI()"
          >
            Switch Now
          </b-button>
          <b-button
            id="switch-new-ui-decline"
            class="ml-1"
            variant="outline-secondary"
            @click="closeSwitchNewUIModal()"
          >
            Maybe Later
          </b-button>
        </div>
        <div v-show="acceptedSwitchNewUI && !acceptedSwitchNewUILoading">
          <h3>Thanks for making the switch!</h3>
          <div>
            You should have received an email with the username/password
            credentials to access the new platform with your email and password.
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Auth, Analytics, graphqlOperation, API } from 'aws-amplify';

import { getUserDisclaimerEntry, getUserSwitchNewUI } from '@/graphql/queries';
import {
  createUserDisclaimerEntry,
  updateUserDisclaimerEntry,
  createUserSwitchNewUI,
} from '@/graphql/mutations';
import { mapGetters, mapMutations } from 'vuex';

import NotificationsPopover from './NotificationsPopover.vue';
import { logError, logMessage } from '@/utils/loggerUtils';

export default {
  name: 'Header',
  components: {
    NotificationsPopover,
  },
  props: {
    projectName: String,
    savedResults: Boolean,
    showProductTour: { type: Boolean, default: false },
  },
  data() {
    return {
      userinfo: {},
      loadedFeedbackForm: false,
      loadedSupportForm: false,
      isDev: process.env.VUE_APP_DEV === 'true',
      isProd: process.env.VUE_APP_PROD === 'true',
      acceptedSwitchNewUI: false,
      acceptedSwitchNewUILoading: false,
    };
  },
  computed: {
    ...mapGetters(['numDocuments']),
  },
  async mounted() {
    this.userinfo = await Auth.currentUserInfo();
    window.heap.identify(this.userinfo.attributes.email);

    logMessage(this.userinfo.attributes.email);

    const switchNewUIResponse = await API.graphql(
      graphqlOperation(getUserSwitchNewUI, {
        id: this.userinfo.attributes.email,
      })
    );
    if (
      switchNewUIResponse.data.getUserSwitchNewUI === null ||
      !switchNewUIResponse.data.getUserSwitchNewUI.accepted
    )
      this.acceptedSwitchNewUI = false;
    else this.acceptedSwitchNewUI = true;

    this.acceptedDisclaimer = localStorage.getItem('disclaimer');
    if (!this.acceptedDisclaimer) {
      const response = await API.graphql(
        graphqlOperation(getUserDisclaimerEntry, {
          id: this.userinfo.attributes.email,
        })
      );
      if (
        response.data.getUserDisclaimerEntry === null ||
        !response.data.getUserDisclaimerEntry.accepted
      )
        this.$bvModal.show('disclaimer-modal');
      else await this.$store.dispatch('setDisclaimer');
    }
    setTimeout(() => {
      this.logout(false);
      // set a timeout of 23 hours
      this.$bvModal.show('logged-out-modal');
    }, 23 * 60 * 60 * 1000);
  },
  methods: {
    ...mapMutations(['resetNotifications']),
    reload() {
      location.reload();
    },
    verifyLogout() {
      Analytics.record({
        name: 'clickLogout',
        attributes: {
          email: this.userinfo.attributes.email,
        },
      });
      this.$bvModal.show('logout-modal');
    },
    cancelLogout() {
      Analytics.record({
        name: 'cancelLogout',
        attributes: {
          email: this.userinfo.attributes.email,
        },
      });
      this.$bvModal.hide('logout-modal');
    },
    async logout(verified = true) {
      Analytics.record({
        name: 'confirmLogout',
        attributes: {
          email: this.userinfo.attributes.email,
        },
      });
      try {
        await this.$store.dispatch('clearInterests');
        await this.$store.dispatch('clearDisclaimer');
        this.resetNotifications();
        await Auth.signOut({ global: true });
        if (verified) this.$router.push({ name: 'Home' });
      } catch (error) {
        logError(error);
        localStorage.clear();
        if (verified) this.$router.push({ name: 'Home' });
      }
    },
    async acceptDisclaimer() {
      await this.$store.dispatch('setDisclaimer');
      this.$bvModal.hide('disclaimer-modal');
      this.acceptedDisclaimer = true;
      const response = await API.graphql(
        graphqlOperation(getUserDisclaimerEntry, {
          id: this.userinfo.attributes.email,
        })
      );
      if (response.data.getUserDisclaimerEntry === null)
        await API.graphql(
          graphqlOperation(createUserDisclaimerEntry, {
            input: {
              id: this.userinfo.attributes.email,
              accepted: true,
            },
          })
        );
      else
        await API.graphql(
          graphqlOperation(updateUserDisclaimerEntry, {
            input: {
              id: this.userinfo.attributes.email,
              accepted: true,
            },
          })
        );
    },
    projectNameBtnClicked() {
      this.$emit('projectNameBtnClicked');
    },
    projectLogBtnClicked() {
      this.$emit('projectLogBtnClicked');
    },
    openSwitchNewUIModal() {
      this.$bvModal.show('switch-new-ui-modal');
    },
    closeSwitchNewUIModal() {
      this.$bvModal.hide('switch-new-ui-modal');
    },
    async acceptSwitchNewUI() {
      this.acceptSwitchNewUILoading = true;
      await API.graphql(
        graphqlOperation(createUserSwitchNewUI, {
          input: {
            id: this.userinfo.attributes.email,
            accepted: true,
          },
        })
      );
      this.acceptSwitchNewUILoading = false;
      this.acceptedSwitchNewUI = true;
      this.$router.push(
        this.isProd
          ? 'https://platform.cedience.com'
          : 'https://stagingplatform.cedience.com'
      );
    },
  },
};
</script>

<style scoped>
[v-cloak] {
  display: none;
}

.link:hover {
  cursor: pointer;
  text-decoration: underline;
}

.top-right-links {
  font-size: 0.9rem;
  display: flex;
  align-items: center;
}

#banner {
  font-family: 'Work Sans', sans-serif;
  /* Set minimum width using StackOverflow answer:
  https://stackoverflow.com/questions/3802455/min-width-in-window-resizing */
  min-width: 1000px; /* Suppose you want minimum width of 1000px */
  width: auto !important; /* Firefox will set width as auto */
  width: 1000px; /* As IE6 ignores !important it will set width as
  1000px; */
}

#cedience-logo {
  height: 78px;
  width: 210px;
}

#header-title {
  text-transform: uppercase;
  color: #6c7a89;
}

#header-title-superscript {
  text-transform: lowercase;
}

#logout-button {
  font-size: 0.95rem;
}

#disclaimer-modal {
  z-index: 2147483647;
}
.project-line {
  margin-left: 1em;
  margin-right: 1em;
}
.project-line-item {
  color: #718fc2;
  text-decoration: none;
}
.project-line-item-inactive {
  color: gray;
  text-decoration: none;
}
.saved-results-link {
  cursor: pointer;
}
#switch-new-ui-button {
  background-color: #f05825;
  color: white;
  border-color: white;
}
</style>
